import { Eye, X } from "lucide-react";

export default function ImpersonationBanner({ adminEmail }) {
  const handleExit = () => {
    sessionStorage.removeItem("impersonate_token");
    sessionStorage.removeItem("impersonate_active");
    window.close();
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-amber-950 py-1.5 px-4 flex items-center justify-center gap-3 text-xs font-medium shadow-md"
      data-testid="impersonation-banner"
    >
      <Eye size={13} className="shrink-0" />
      <span>
        You are viewing this account as <strong>{adminEmail || "admin"}</strong>
      </span>
      <button
        onClick={handleExit}
        className="ml-2 px-2.5 py-0.5 rounded bg-amber-600 hover:bg-amber-700 text-white text-[11px] font-medium transition-colors flex items-center gap-1"
        data-testid="exit-impersonation"
      >
        <X size={11} /> Exit
      </button>
    </div>
  );
}
